import request from '@/utils/request'

export function fetchModuleList(data) {
  return request({
    url: '/v1/category-fe/list',
    method: 'get',
    params: data
  })
}
